import styled from 'styled-components';
import Search from '../../../../Search';

const StyledTableFilters = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledTableFiltersSearch = styled(Search)`
  min-height: 40px;
  max-width: 264px;
  min-width: 150px;
  width: 100%;
`;

const StyledTableFiltersElements = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow-x: auto;

  .table-filters-right-side-content {
    margin-left: 62px;
  }

  .ant-select-single.ant-select-lg {
    .ant-select-selector {
      min-height: 40px;
    }
  }

  .ant-select-multiple.ant-select-lg {
    .ant-select-selection-overflow {
      flex-wrap: nowrap;
    }
  }

  .ant-picker {
    min-height: 40px;
    min-width: 176px;
    max-width: 270px;
    width: auto;

    &.ant-picker-large {
      padding-left: 4px !important;
    }

    .ant-picker-prefix {
      button {
        padding: 0 4px;
      }
    }
  }

  .ant-select-multiple {
    .ant-select-selector {
      height: 40px;
      padding-block: 2px;
    }
    .ant-select-selection-overflow {
      height: 36px;
    }
  }
`;

const StyledTableFiltersLeftSideContent = styled.div`
  display: flex;
`;

export {
  StyledTableFiltersSearch,
  StyledTableFilters,
  StyledTableFiltersElements,
  StyledTableFiltersLeftSideContent,
};
